{
  "common": {
    "cancel": "Annuleren",
    "save": "Opslaan",
    "delete": "Verwijderen",
    "done": "Klaar",
    "edit": "Bewerken",
    "search": "Zoeken",
    "loading": "Laden…",
    "yes": "Ja",
    "no": "Nee",
    "settings": "Instellingen",
    "back": "Terug",
    "close": "Sluiten",
    "open": "Openen",
    "copy": "Kopiëren",
    "restore": "Herstellen",
    "untitled": "Naamloos",
    "create": "Aanmaken",
    "revoke": "Intrekken",
    "never": "Nooit",
    "tryAgain": "Opnieuw proberen",
    "reload": "Opnieuw laden",
    "update": "Bijwerken",
    "insert": "Invoegen",
    "loadingShort": "Laden",
    "unknown": "Onbekend",
    "sampleSentence": "De snelle bruine vos"
  },
  "sidebar": {
    "views": "Weergaven",
    "tags": "Labels",
    "edit": "Bewerken",
    "done": "Klaar",
    "account": "Account",
    "newNote": "Nieuwe notitie",
    "editTag": "Label bewerken",
    "tagOptions": "Labelopties",
    "reorder": "Verplaats {{label}}",
    "showView": "{{label}} tonen",
    "hideView": "{{label}} verbergen",
    "editViews": "Weergaven bewerken",
    "doneEditingViews": "Klaar met bewerken",
    "samplePeep": "Caliu is…",
    "sampleQuiet": "Een rustige plek waar je gedachten kunnen leven en ademen."
  },
  "views": {
    "all": "Alle notities",
    "today": "Vandaag",
    "todo": "Taken",
    "pinned": "Vastgezet",
    "untagged": "Zonder labels",
    "thisWeek": "Deze week",
    "shared": "Door mij gedeeld",
    "sharedWithMe": "Met mij gedeeld",
    "attachments": "Bijlagen",
    "trash": "Prullenbak",
    "archive": "Gearchiveerd"
  },
  "noteList": {
    "empty": "Nog geen notities",
    "emptySubtitle": "Maak je eerste notitie om te beginnen.",
    "untitled": "Naamloos",
    "selectNote": "Kies een notitie",
    "selectNoteHint": "Kies een notitie uit de lijst, of maak een nieuwe.",
    "selectRestoreOrDelete": "Kies een notitie om te herstellen of definitief te verwijderen",
    "selectSharedToView": "Kies een gedeelde notitie om te bekijken",
    "searchPlaceholder": "Notities zoeken…",
    "selectNotes": "Notities selecteren",
    "openSidebar": "Zijbalk openen",
    "cancelSelection": "Selectie annuleren",
    "clearSelection": "Selectie wissen",
    "emptyTrash": "Prullenbak legen",
    "newNote": "Nieuwe notitie",
    "noteCount_one": "{{count}} notitie",
    "noteCount_other": "{{count}} notities",
    "sortBy": "Sorteren op",
    "preview": "Voorvertoning",
    "modificationDate": "Wijzigingsdatum",
    "creationDate": "Aanmaakdatum",
    "title": "Titel",
    "manual": "Handmatig",
    "newestOnTop": "Nieuwste bovenaan",
    "small": "Klein",
    "medium": "Middel",
    "large": "Groot",
    "empty_pinned": "Nog niets vastgezet",
    "empty_pinned_subtitle": "Zet een notitie vast om die hier snel te vinden.",
    "empty_today": "Vandaag nog niets bewerkt",
    "empty_today_subtitle": "Notities die je vandaag bewerkt verschijnen hier.",
    "empty_todo": "Nog geen taken",
    "empty_todo_subtitle": "Notities met open taken verschijnen hier.",
    "empty_untagged": "Alles heeft een label",
    "empty_untagged_subtitle": "Notities zonder labels verschijnen hier.",
    "empty_thisWeek": "Niets deze week",
    "empty_thisWeek_subtitle": "Notities van de afgelopen 7 dagen verschijnen hier.",
    "empty_shared": "Geen gedeelde notities",
    "empty_shared_subtitle": "Notities die je deelt verschijnen hier.",
    "empty_attachments": "Nog geen bijlagen",
    "empty_attachments_subtitle": "Notities met afbeeldingen of bestanden verschijnen hier.",
    "justNow": "Zojuist",
    "minutesAgo": "{{count}} min geleden",
    "today": "Vandaag",
    "yesterday": "Gisteren",
    "deletedOn": "Verwijderd op {{date}}",
    "newNoteShortcut": "Nieuwe notitie ({{shortcut}})",
    "noContent": "Geen inhoud",
    "selectUnarchiveOrDelete": "Selecteer een notitie om deze uit het archief te halen of te verwijderen",
    "view": "Weergave",
    "density": "Dichtheid",
    "exportAll": "Alles exporteren"
  },
  "editor": {
    "attachmentTooLarge": "Dit bestand is te groot om bij te voegen. De limiet is 100 MB.",
    "placeholder": "Begin met schrijven…",
    "noMatchingCommands": "Geen overeenkomende commando's",
    "newNote": "nieuwe notitie",
    "noResults": "Geen resultaten",
    "foldSection": "Sectie invouwen",
    "unfoldSection": "Sectie uitvouwen",
    "dragSection": "Sectie verplaatsen",
    "presenceLabel": "Ook hier: {{names}}"
  },
  "noteActions": {
    "pin": "Vastzetten",
    "unpin": "Losmaken",
    "pinToTop": "Bovenaan vastzetten",
    "makeReadOnly": "Alleen-lezen maken",
    "makeEditable": "Bewerkbaar maken",
    "readOnlyNote": "Alleen-lezen notitie",
    "shareNote": "Notitie delen",
    "share": "Delen",
    "publiclyShared": "Openbaar gedeeld",
    "privateNote": "Privénotitie",
    "linkCreated": "Link aangemaakt",
    "linkCreatedAndCopied": "Link aangemaakt en gekopieerd",
    "linkRevoked": "Deellink ingetrokken",
    "failedToCreateShareLink": "Kon deellink niet aanmaken",
    "failedToRevokeShareLink": "Kon deellink niet intrekken",
    "thisNoteIsPrivate": "Deze notitie is privé.",
    "createPublicLink": "Openbare link maken",
    "creatingLink": "Link aanmaken…",
    "revokeLink": "Link intrekken",
    "revokingLink": "Intrekken…",
    "copyLink": "Link kopiëren",
    "copyNoteId": "Notitie-ID kopiëren",
    "noteIdCopied": "Notitie-ID gekopieerd",
    "exportAs": "Exporteren als",
    "exportMarkdown": "Markdown",
    "exportPlainText": "Platte tekst",
    "exportHtml": "HTML",
    "exportRtf": "RTF",
    "exportEpub": "ePub",
    "exportTextpack": "TextPack",
    "exportFailed": "Export mislukt",
    "viewHistory": "Geschiedenis bekijken",
    "duplicate": "Dupliceren",
    "duplicateFailed": "Kon notitie niet dupliceren",
    "select": "Selecteren",
    "delete": "Verwijderen",
    "moveToTrash": "Naar prullenbak",
    "archive": "Archiveren",
    "unarchive": "Uit archief halen",
    "tags": "Labels",
    "addTag": "Label toevoegen",
    "noTagsYet": "Nog geen labels",
    "addTagFailed": "Kan label niet toevoegen",
    "removeTagFailed": "Kan label niet verwijderen"
  },
  "userMenu": {
    "theme": "Thema",
    "typography": "Typografie",
    "language": "Taal",
    "apiKeys": "API-sleutels",
    "devices": "Apparaten",
    "connectedApps": "Verbonden apps",
    "help": "Hulp",
    "logOut": "Uitloggen",
    "defaultUserName": "Caliu-gebruiker",
    "editName": "Naam bewerken",
    "nameLabel": "Naam",
    "namePlaceholder": "Je naam",
    "upgradeToPro": "Upgraden naar Caliu Pro",
    "replayOnboarding": "Speel introductie opnieuw af",
    "logOutTitle": "Uitloggen?",
    "logOutBody": "Je notities blijven op dit apparaat en je kunt ze blijven lezen en schrijven. Log weer in om te synchroniseren.",
    "logOutPending_one": "{{count}} wijziging is nog niet gesynchroniseerd. Die blijft op dit apparaat tot je weer inlogt.",
    "logOutPending_other": "{{count}} wijzigingen zijn nog niet gesynchroniseerd. Die blijven op dit apparaat tot je weer inlogt.",
    "logOutKeep": "Uitloggen",
    "logOutAndRemove": "Uitloggen en notities verwijderen"
  },
  "help": {
    "title": "Helpcentrum",
    "searchPlaceholder": "Zoek in helpartikelen",
    "noResults": "Geen artikelen komen overeen met je zoekopdracht.",
    "offline": "Hulp is offline niet beschikbaar. Deze wordt geladen zodra je weer verbinding hebt."
  },
  "fonts": {
    "uiFont": "UI-lettertype",
    "body": "Tekst",
    "headings": "Koppen",
    "code": "Code",
    "sans": "Sans",
    "serif": "Serif",
    "mono": "Mono",
    "editor": "Editor",
    "ui": "Interface",
    "reset": "Standaard herstellen"
  },
  "themes": {
    "light": "Licht",
    "dark": "Donker",
    "system": "Systeem"
  },
  "languages": {
    "systemHint": "Gedetecteerd van je apparaat",
    "names": {
      "en": "Engels",
      "es": "Spaans",
      "ca": "Catalaans",
      "fr": "Frans",
      "de": "Duits",
      "it": "Italiaans",
      "pt": "Portugees",
      "nl": "Nederlands",
      "ja": "Japans",
      "zh-CN": "Chinees (vereenvoudigd)",
      "ko": "Koreaans",
      "zh-TW": "Chinees (traditioneel)",
      "ru": "Russisch"
    }
  },
  "bulkActions": {
    "pinSelected": "Selectie vastzetten",
    "unpinSelected": "Selectie losmaken",
    "pin": "Vastzetten",
    "addTag": "Label toevoegen",
    "filterTags": "Labels filteren…",
    "noTagsFound": "Geen labels gevonden",
    "exportSelected": "Selectie exporteren",
    "restoreSelected": "Selectie herstellen",
    "deletePermanently": "Permanent verwijderen",
    "moveToTrash": "Naar prullenbak",
    "archiveSelected": "Selectie archiveren",
    "unarchiveSelected": "Selectie uit archief halen",
    "exportingTitle": "Je notities worden geëxporteerd",
    "exportingBody": "Dit kan even duren. Houd dit tabblad open tot het klaar is.",
    "exportingProgress": "{{done}} van {{total}}"
  },
  "commandPalette": {
    "placeholder": "Zoek notities, labels, commando's…",
    "noResults": "Geen resultaten voor \"{{query}}\"",
    "currentNote": "Huidige notitie",
    "navigation": "Navigatie",
    "notes": "Notities",
    "tags": "Labels",
    "newNote": "Nieuwe notitie",
    "allNotes": "Alle notities",
    "todaysNotes": "Notities van vandaag",
    "todo": "Taken",
    "pinnedNotes": "Vastgezette notities",
    "trash": "Prullenbak",
    "importNotes": "Notities importeren",
    "changeTheme": "Thema wijzigen",
    "keyboardShortcuts": "Sneltoetsen",
    "pinNote": "Notitie vastzetten",
    "unpinNote": "Notitie losmaken",
    "restoreNote": "Notitie herstellen",
    "copyShareLink": "Deellink kopiëren",
    "makePrivate": "Privé maken",
    "toggleFullscreen": "Volledig scherm",
    "noteInfo": "Notitie-info",
    "moveToTrash": "Naar prullenbak",
    "archiveNote": "Notitie archiveren",
    "unarchiveNote": "Notitie uit archief halen",
    "archive": "Gearchiveerd"
  },
  "noteHistory": {
    "title": "Notitiegeschiedenis",
    "requiresConnection": "Geschiedenis vereist een verbinding.",
    "reconnect": "Verbind opnieuw met internet en probeer opnieuw.",
    "noHistory": "Nog geen geschiedenis voor deze notitie.",
    "windowMerged": "Bewerkingen binnen een venster van 5 minuten worden tot één invoer samengevoegd.",
    "selectVersion": "Kies een versie om te bekijken",
    "encrypted": "Versleutelde versie",
    "encryptedHint": "Deze versie is opgeslagen met eind-tot-eindversleuteling. Open de notitie om de huidige inhoud te zien.",
    "restoreVersion": "Deze versie herstellen?",
    "restoreVersionHint": "Hierdoor wordt de huidige inhoud van de notitie vervangen door de versie van {{date}}.",
    "current": "Huidig",
    "created": "Aangemaakt",
    "trashed": "Verwijderd",
    "restored": "Hersteld",
    "edited": "Bewerkt"
  },
  "apiKeys": {
    "title": "API-sleutels",
    "empty": "Nog geen API-sleutels.",
    "emptyHint": "Maak er een aan om de API te gebruiken.",
    "created": "Aangemaakt op {{date}}",
    "lastUsed": "Laatst gebruikt: {{date}}",
    "revokeKey": "Sleutel intrekken",
    "viewApiDocs": "API-documentatie",
    "newApiKey": "Nieuwe API-sleutel",
    "apiKeyCreated": "API-sleutel aangemaakt",
    "createApiKey": "API-sleutel aanmaken",
    "copyHint": "Kopieer deze sleutel nu. Je kunt hem niet meer zien.",
    "copyToClipboard": "Naar klembord kopiëren",
    "keyName": "Sleutelnaam",
    "keyNamePlaceholder": "bv. Mijn script, Zapier-integratie",
    "createKey": "Sleutel aanmaken",
    "revokeKeyTitle": "API-sleutel intrekken",
    "revokeKeyHint": "Hiermee wordt deze API-sleutel permanent ingetrokken. Toepassingen die hem gebruiken verliezen onmiddellijk toegang.",
    "keyPrefix": "caliu_{{prefix}}…"
  },
  "connectedApps": {
    "title": "Verbonden apps",
    "empty": "Nog geen verbonden apps.",
    "emptyHint": "Verbind Claude, ChatGPT of een andere AI-assistent om je notities vanuit de chat te gebruiken. De sectie Caliu met AI in Hulp legt uit hoe.",
    "connected": "Verbonden op {{date}}",
    "lastUsed": "Laatst gebruikt: {{date}}",
    "revoke": "Intrekken",
    "revokeTitle": "Verbinding intrekken",
    "revokeHint": "Hiermee wordt de toegang van <strong>{{name}}</strong> tot je Caliu-account ingetrokken en worden de gebruikte gegevens verwijderd. Het verliest onmiddellijk toegang.",
    "thisApp": "deze app",
    "defaultScope": "mcp"
  },
  "noteStats": {
    "writing": "Schrijven",
    "metadata": "Metadata",
    "words": "Woorden",
    "characters": "Tekens",
    "paragraphs": "Alinea’s",
    "readTime": "Leestijd",
    "minutes": "{{count}} min",
    "tags": "Labels",
    "outgoingLinks": "Uitgaande links",
    "backlinks": "Terugverwijzingen",
    "created": "Aangemaakt",
    "modified": "Gewijzigd",
    "noteStatistics": "Notitie-statistieken",
    "identifier": "Identificatie"
  },
  "inspector": {
    "tabInfo": "Info",
    "tabOutline": "Overzicht",
    "tabHistory": "Geschiedenis",
    "dates": "Datums",
    "noHeadings": "Geen koppen in deze notitie",
    "noBacklinks": "Geen notities linken hierheen",
    "noOutgoing": "Deze notitie linkt nergens naartoe",
    "noAttachments": "Geen bijlagen in deze notitie",
    "historyOffline": "Versiegeschiedenis vereist een verbinding",
    "historyLoadMore": "Meer laden"
  },
  "devices": {
    "title": "Apparaten",
    "offline": "Je bent offline.",
    "offlineHint": "Maak verbinding met internet om je apparaten te zien.",
    "noSessions": "Geen actieve sessies gevonden.",
    "thisDevice": "Dit apparaat",
    "lastUsed": "Laatst gebruikt: {{date}}",
    "created": "Aangemaakt: {{date}}",
    "signOutCurrent": "Op dit apparaat afmelden",
    "signOut": "Afmelden",
    "confirmCurrentTitle": "Uitloggen op dit apparaat?",
    "confirmRevokeTitle": "Apparaat intrekken?",
    "confirmCurrentBody": "Je wordt op deze browser afgemeld bij Caliu en de notities worden van dit apparaat verwijderd. Log op elk moment weer in, dan komen ze terug uit je account.",
    "confirmRevokeBody": "Het apparaat wordt direct afgemeld. Niet-gesynchroniseerde wijzigingen blijven daar tot je opnieuw inlogt.",
    "revoke": "Intrekken"
  },
  "errorScreen": {
    "title": "Er ging iets mis",
    "defaultMessage": "Er trad een onverwachte fout op. Probeer de pagina opnieuw te laden."
  },
  "importModal": {
    "title": "Notities importeren",
    "dropToImport": "Laat los om te importeren",
    "dropOrClick": "Sleep bestanden of klik om te bladeren",
    "removeFile": "Bestand verwijderen",
    "keepNote": "Voor Google Keep: exporteer een Takeout-ZIP en upload dat archief direct.",
    "importedCount_one": "<strong>{{count}}</strong> notitie geïmporteerd",
    "importedCount_other": "<strong>{{count}}</strong> notities geïmporteerd",
    "fromSource": " uit {{source}}",
    "importing": "Importeren…",
    "importN": "{{count}} bestanden importeren",
    "importBtn": "Importeren"
  },
  "share": {
    "shareNote": "Notitie delen",
    "publiclySharedAria": "Notitie is openbaar gedeeld",
    "copyLink": "Link kopiëren",
    "revokingLink": "Intrekken…",
    "revokeLink": "Link intrekken",
    "creatingLink": "Link maken…",
    "createPublicLink": "Openbare link maken",
    "shareThisNotePublicly": "Deze notitie openbaar delen",
    "thisNoteIsPrivate": "Deze notitie is privé.",
    "publiclyShared": "Openbaar gedeeld",
    "privateNote": "Privénotitie"
  },
  "shortcuts": {
    "searchPlaceholder": "Zoek sneltoetsen…",
    "pressNew": "Druk op de nieuwe sneltoets…",
    "resetToDefault": "Naar standaard terugzetten",
    "noMatches": "Geen sneltoetsen voor “<strong>{{query}}</strong>”",
    "navigate": "navigeren",
    "edit": "bewerken",
    "closeAction": "sluiten",
    "resetAll": "Alles resetten"
  },
  "tagEditor": {
    "icon": "Pictogram",
    "color": "Kleur",
    "searchIcons": "Pictogrammen zoeken",
    "noIcons": "Geen pictogrammen gevonden",
    "categories": {
      "essentials": "Basis",
      "work": "Werk en techniek",
      "ideas": "Ideeën en creativiteit",
      "life": "Mensen en thuis",
      "travel": "Reizen en natuur",
      "fun": "Eten, gezondheid en vrije tijd"
    }
  },
  "tagActions": {
    "pin": "Label vastzetten",
    "unpin": "Label losmaken",
    "rename": "Naam wijzigen…",
    "renameTitle": "Labelnaam wijzigen",
    "renameConfirm": "Naam wijzigen",
    "renameHint": "Het label wordt bijgewerkt in elke notitie die het gebruikt, inclusief gearchiveerde notities en de prullenbak.",
    "renamed": "Labelnaam gewijzigd",
    "nameInUse": "Die naam is al in gebruik",
    "invalidName": "Labelnamen mogen alleen letters, cijfers, spaties, koppeltekens en underscores bevatten",
    "pinFailed": "Kan label niet bijwerken",
    "renameFailed": "Kan labelnaam niet wijzigen",
    "editAppearance": "Uiterlijk bewerken"
  },
  "auth": {
    "appName": "Caliu",
    "or": "of",
    "email": "E-mail",
    "emailPlaceholder": "jij@voorbeeld.com",
    "password": "Wachtwoord",
    "passwordPlaceholder": "Wachtwoord",
    "name": "Naam",
    "namePlaceholder": "Je naam",
    "confirmPassword": "Wachtwoord bevestigen",
    "newPassword": "Nieuw wachtwoord",
    "confirmNewPassword": "Nieuw wachtwoord bevestigen",
    "signInSubtitle": "Log in op je account",
    "createAccountSubtitle": "Maak je account aan",
    "forgotPassword": "Wachtwoord vergeten?",
    "signingIn": "Aanmelden…",
    "signIn": "Aanmelden",
    "noAccount": "Geen account?",
    "signUp": "Account aanmaken",
    "haveAccount": "Heb je al een account?",
    "creatingAccount": "Account aanmaken…",
    "createAccount": "Account aanmaken",
    "googleSignUpAria": "Registreren met Google",
    "signupClosedTitle": "Aanmelden is momenteel gesloten",
    "signupClosedBody": "Caliu is in private beta. Schrijf je in op de wachtlijst op caliuapp.com voor vroege toegang.",
    "joinWaitlist": "Inschrijven op de wachtlijst",
    "forgotTitle": "Wachtwoord opnieuw instellen",
    "forgotSubtitle": "Vul je e-mail in en we sturen je een resetlink.",
    "sendResetLink": "Resetlink versturen",
    "sending": "Versturen…",
    "checkYourEmail": "Controleer je e-mail",
    "resetLinkSentPrefix": "Als ",
    "resetLinkSentSuffix": " een account heeft, hebben we een resetlink verstuurd. Deze verloopt binnen 1 uur.",
    "backToSignIn": "Terug naar aanmelden",
    "verifySentPrefix": "We hebben een verificatielink gestuurd naar ",
    "verifySentSuffix": ". Klik erop om je account te activeren.",
    "linkExpires10m": "De link verloopt over 10 minuten.",
    "resending": "Opnieuw versturen…",
    "resendEmail": "E-mail opnieuw versturen",
    "wrongEmail": "Verkeerde e-mail?",
    "goBack": "Terug",
    "invalidResetLinkTitle": "Ongeldige resetlink",
    "invalidResetLinkBody": "Deze link is ongeldig of verlopen.",
    "requestNewLink": "Nieuwe link aanvragen",
    "setNewPasswordTitle": "Nieuw wachtwoord instellen",
    "setNewPasswordHint": "Kies een sterk wachtwoord.",
    "updatingPassword": "Bijwerken…",
    "updatePassword": "Wachtwoord bijwerken",
    "localNotesTitle": "Je hebt notities op dit apparaat",
    "localNotesBody_one": "Je schreef hier {{count}} notitie voordat je inlogde. Wat moet ermee gebeuren?",
    "localNotesBody_other": "Je schreef hier {{count}} notities voordat je inlogde. Wat moet ermee gebeuren?",
    "localNotesDelete": "Verwijderen",
    "localNotesMerge": "Toevoegen aan mijn account",
    "backToMyNotes": "Terug naar mijn notities",
    "errorGoogleAuthFailed": "Inloggen met Google is mislukt. Probeer het opnieuw.",
    "errorInvalidToken": "Ongeldige verificatielink. Registreer opnieuw.",
    "errorEmailTaken": "Dit e-mailadres is al in gebruik. Log in.",
    "signInInstead": "Log in bij dat account",
    "errorIdentityTaken": "Deze identiteit hoort al bij een ander Caliu-account. Log daar in.",
    "parkedNotesTitle": "Notities van een ander account",
    "parkedNotesBody_one": "Meld je aan bij {{email}} om de notities van dat account op dit apparaat te houden. Een ander account wist de ene notitie die hier staat, inclusief alles wat er sindsdien is geschreven.",
    "parkedNotesBody_other": "Meld je aan bij {{email}} om de notities van dat account op dit apparaat te houden. Een ander account wist alle {{count}} notities die hier staan, inclusief alles wat er sindsdien is geschreven.",
    "parkedNotesBodyNoEmail_one": "Meld je aan bij het account waarbij je bent afgemeld om de notities van dat account op dit apparaat te houden. Een ander account wist de ene notitie die hier staat, inclusief alles wat er sindsdien is geschreven.",
    "parkedNotesBodyNoEmail_other": "Meld je aan bij het account waarbij je bent afgemeld om de notities van dat account op dit apparaat te houden. Een ander account wist alle {{count}} notities die hier staan, inclusief alles wat er sindsdien is geschreven.",
    "parkedNotesContinue": "Doorgaan"
  },
  "connectors": {
    "wantsAccess": "wil toegang tot Caliu",
    "couldntLoad": "Kan dit verzoek niet laden",
    "authorize": "Autoriseren",
    "keepHappeningHint": "Als dit blijft gebeuren, verwijder de connector uit je MCP-client en voeg hem opnieuw toe.",
    "backToCaliu": "Terug naar Caliu",
    "askingPermissionPrefix": "vraagt toestemming om je notities en labels te lezen en aan te passen via de MCP-server van Caliu.",
    "signedInAs": "Aangemeld als {{name}}.",
    "permissions": "Toestemmingen",
    "deny": "Weigeren",
    "allow": "Toestaan"
  },
  "editorTypography": {
    "fontSize": "Lettergrootte",
    "lineHeight": "Regelhoogte",
    "paragraphSpacing": "Alineaspatiëring"
  },
  "emptyState": {
    "cmdGlyph": "⌘",
    "ctrlGlyph": "Ctrl",
    "shiftGlyph": "Shift"
  },
  "floatingMenu": {
    "undo": "Ongedaan maken",
    "redo": "Opnieuw",
    "taskList": "Takenlijst",
    "bulletList": "Opsomming",
    "orderedList": "Genummerde lijst",
    "blockQuote": "Blokquote",
    "separator": "Scheidingslijn",
    "insertTag": "Label invoegen",
    "highlight": "Markeren",
    "math": "Formule",
    "removeHighlight": "Markering verwijderen",
    "inlineCode": "Inlinecode",
    "codeBlock": "Codeblok",
    "insertTable": "Tabel invoegen",
    "insertImage": "Afbeelding invoegen",
    "hideStyleBar": "Stijlbalk verbergen",
    "attachFile": "Bestand bijvoegen",
    "photoLibrary": "Fotobibliotheek",
    "camera": "Camera",
    "fromFile": "Uit bestand"
  },
  "imageDialog": {
    "title": "Afbeelding invoegen",
    "tabUpload": "Bestand",
    "tabUrl": "URL",
    "urlLabel": "Afbeeldings-URL",
    "urlPlaceholder": "https://voorbeeld.com/afbeelding.jpg",
    "altLabel": "Alt-tekst",
    "altPlaceholder": "Beschrijf de afbeelding…",
    "previewAlt": "voorbeeld",
    "changeImage": "Afbeelding wijzigen",
    "dropToInsert": "Laat los om in te voegen",
    "dropOrClick": "Sleep een afbeelding of klik om te bladeren",
    "formats": "PNG, JPG, GIF, WebP",
    "insert": "Afbeelding invoegen"
  },
  "linkDialog": {
    "editTitle": "Link bewerken",
    "insertTitle": "Link invoegen",
    "textLabel": "Tekst",
    "textPlaceholder": "Linktekst",
    "urlPlaceholder": "https://voorbeeld.com",
    "removeLink": "Link verwijderen",
    "openLink": "Link openen",
    "editLink": "Link bewerken"
  },
  "noteEditor": {
    "notFound": "Notitie niet gevonden.",
    "inTrashBanner": "Deze notitie staat in de prullenbak. Herstel hem om te bewerken.",
    "restore": "Herstellen",
    "noContent": "Deze notitie heeft geen inhoud."
  },
  "noteHeader": {
    "noteInfo": "Notitie-info"
  },
  "table": {
    "deleteRow": "Rij verwijderen",
    "deleteTable": "Tabel verwijderen",
    "addRow": "Rij toevoegen",
    "addRowAbove": "Rij hierboven toevoegen",
    "addColumn": "Kolom toevoegen",
    "addColumnBefore": "Kolom ervoor toevoegen",
    "moveRowUp": "Rij omhoog verplaatsen",
    "moveRowDown": "Rij omlaag verplaatsen",
    "moveColumnLeft": "Kolom naar links verplaatsen",
    "moveColumnRight": "Kolom naar rechts verplaatsen",
    "deleteColumn": "Kolom verwijderen",
    "actions": "Tabelacties"
  },
  "syncIndicator": {
    "synced": "Gesynchroniseerd",
    "pending_one": "{{count}} synchronisatie in wachtrij",
    "pending_other": "{{count}} synchronisaties in wachtrij",
    "offline": "Offline",
    "offlinePending_one": "Offline · {{count}} in wachtrij",
    "offlinePending_other": "Offline · {{count}} in wachtrij",
    "syncing": "Synchroniseren...",
    "conflict_one": "{{count}} conflict",
    "conflict_other": "{{count}} conflicten",
    "error": "Synchronisatiefout",
    "syncedTooltip": "Alle wijzigingen opgeslagen",
    "pendingTooltip_one": "{{count}} wijziging wacht op synchronisatie",
    "pendingTooltip_other": "{{count}} wijzigingen wachten op synchronisatie",
    "offlineTooltip": "Offline: wijzigingen worden gesynchroniseerd zodra je weer verbinding hebt",
    "offlinePendingTooltip_one": "Offline: {{count}} wijziging wordt gesynchroniseerd zodra je weer verbinding hebt",
    "offlinePendingTooltip_other": "Offline: {{count}} wijzigingen worden gesynchroniseerd zodra je weer verbinding hebt",
    "syncingTooltip": "Synchroniseren...",
    "syncingPendingTooltip_one": "{{count}} wijziging in wachtrij synchroniseren...",
    "syncingPendingTooltip_other": "{{count}} wijzigingen in wachtrij synchroniseren...",
    "conflictTooltip_one": "{{count}} notitie heeft conflicterende wijzigingen. Klik om op te lossen.",
    "conflictTooltip_other": "{{count}} notities hebben conflicterende wijzigingen. Klik om op te lossen.",
    "errorTooltip": "Synchronisatie mislukt. Er wordt automatisch opnieuw geprobeerd.",
    "conflictsTitle": "Conflicten oplossen",
    "local": "Op dit apparaat",
    "localTooltip": "Alleen op dit apparaat. Log in om te synchroniseren."
  },
  "image": {
    "download": "Afbeelding downloaden",
    "replace": "Afbeelding vervangen",
    "remove": "Afbeelding verwijderen"
  },
  "sharePage": {
    "goToCaliu": "Naar Caliu",
    "noteNotFoundTitle": "Notitie niet gevonden",
    "somethingWentWrong": "Er ging iets mis",
    "lastUpdated": "Laatst bijgewerkt: {{date}}",
    "tagline": "Een notitie-app voor denkers",
    "subtagline": "Schrijf in markdown. Synchroniseer overal. Denk helder.",
    "startWriting": "Beginnen met schrijven",
    "signIn": "Aanmelden",
    "openInCaliu": "Openen in Caliu",
    "adding": "Toevoegen…",
    "addToSharedList": "Toevoegen aan mijn gedeelde lijst",
    "notFoundSubtitle": "Deze deellink is mogelijk verlopen of ingetrokken.",
    "errorSubtitle": "Kan deze notitie niet laden. Probeer het opnieuw."
  },
  "sharedView": {
    "loading": "Gedeelde notitie laden…",
    "sharedWithYou": "Met jou gedeeld",
    "viewRaw": "Ruwe Markdown weergeven",
    "viewRendered": "Opgemaakte notitie weergeven",
    "copyMarkdown": "Markdown kopiëren",
    "markdownCopied": "Markdown gekopieerd",
    "copyFailed": "Kopiëren mislukt",
    "notLoadedYet": "Deze notitie is nog niet geladen",
    "linkCopied": "Link gekopieerd",
    "actions": "Notitieacties"
  },
  "sharedWithMe": {
    "title": "Met mij gedeeld",
    "removeFromList": "Uit lijst verwijderen",
    "empty": "Nog geen gedeelde notities",
    "emptyHint": "Open een gedeelde Caliu-link van een vriend om hem hier toe te voegen. Gedeelde notities synchroniseren op al je apparaten."
  },
  "trashView": {
    "empty": "De prullenbak is leeg",
    "emptyHint": "Verwijderde notities verschijnen hier",
    "retention": "Notities in de prullenbak worden na 30 dagen definitief verwijderd",
    "trash": "Prullenbak"
  },
  "fileAttachment": {
    "download": "Bestand downloaden",
    "remove": "Bestand verwijderen"
  },
  "archiveView": {
    "archive": "Gearchiveerd",
    "empty": "Het archief is leeg",
    "emptyHint": "Gearchiveerde notities verschijnen hier",
    "archivedOn": "Gearchiveerd op {{date}}"
  },
  "pro": {
    "subtitle": "Caliu, zonder grenzen.",
    "features": [
      "Onbeperkt notities",
      "Versiegeschiedenis van notities",
      "Export naar PDF, HTML, RTF, ePub + bulk",
      "Alle thema's, lettertypen en app-iconen",
      "Steunt de ontwikkeling van Caliu"
    ],
    "perMonth": "{{price}} per maand",
    "perWeek": "{{price}} per week",
    "oneTime": "{{price}} eenmalig",
    "perYear": "{{price}} per jaar",
    "or": "of",
    "signInToSubscribe": "Log in om een abonnement te nemen",
    "accountRequired": "Caliu Pro is gekoppeld aan je account en wordt dus op al je apparaten ontgrendeld.",
    "plansUnavailable": "We konden de abonnementen niet laden. Controleer je verbinding en probeer het opnieuw.",
    "yearly": "Jaarlijks",
    "monthly": "Maandelijks",
    "continue": "Doorgaan",
    "bestValue": "Beste keuze",
    "autoRenew": "{{amount}}. Verlengt automatisch tot je opzegt. Altijd opzegbaar.",
    "freeTrial": "{{count}} dagen gratis",
    "billedSubtitle": "{{count}} dagen gratis, daarna {{amount}}. Altijd opzegbaar.",
    "startTrial": "Gratis proberen",
    "upgradeSubtitle": "Versiegeschiedenis, alle thema's en lettertypen, exporteren en meer.",
    "upgradeNow": "Nu upgraden",
    "thanks": "Bedankt dat je Caliu steunt!",
    "renewsOn": "Wordt verlengd op {{date}}",
    "endsOn": "Eindigt op {{date}}",
    "lifetime": "Levenslange toegang",
    "lifetimePlan": "Levenslang",
    "oneTimeNoRenewal": "Eenmalige betaling",
    "launchPrice": "Introductieprijs. Later stijgt de prijs naar {{price}}.",
    "buy": "Kopen",
    "oneTimeDisclosure": "{{amount}}. Eenmalige betaling, geen verlenging.",
    "thanksMessage": "Je steun houdt Caliu onafhankelijk en privé.",
    "manageSubscription": "Abonnement beheren",
    "contactUs": "Vragen? Neem contact op",
    "grandfatheredNote": "Als vroege supporter is Caliu Pro voor het leven van jou. Niets te verlengen.",
    "webFootnote": "PDF-export is nog niet beschikbaar op het web.",
    "active": "Actief"
  },
  "find": {
    "placeholder": "Zoeken in notitie",
    "matchCount": "{{current}}/{{total}}",
    "noResults": "Geen resultaten",
    "next": "Volgende match",
    "previous": "Vorige match",
    "close": "Sluiten"
  },
  "conflicts": {
    "description": "Deze notitie is op een ander apparaat bewerkt. Behoud één versie.",
    "yours": "Jouw versie",
    "theirs": "Andere versie",
    "step": "{{current}} van {{total}}",
    "keepYours": "Jouw versie behouden",
    "keepTheirs": "Andere behouden",
    "serverError": "Kan de andere versie niet laden.",
    "done": "Alle conflicten opgelost.",
    "previous": "Vorig conflict",
    "next": "Volgend conflict",
    "copyOf": "Kopie van {{title}}"
  },
  "onboarding": {
    "welcomeTitle": "Welkom bij Caliu",
    "welcomeSubtitle": "Een rustige plek waar je gedachten kunnen leven en ademen.",
    "getStarted": "Aan de slag",
    "magicTitle": "Zie je woorden vorm krijgen",
    "magicSubtitle": "Jij typt gewone tekst. Caliu maakt er structuur van: taken, markeringen en labels die zichzelf ordenen.",
    "magicLearnMore": "Leer de basis van Markdown",
    "replay": "Opnieuw afspelen",
    "demoTitle": "Zomer aan zee",
    "demoBody": "Een **rustige week** in een klein dorp plannen.",
    "demoTask": "Het huisje boeken",
    "demoHighlight": "Zwemmen ==voor== het ontbijt",
    "demoTags": "#zomer #plannen",
    "intentTitle": "Wat breng je hier naartoe?",
    "intentSubtitle": "Kies er een paar. Je eerste notitie en labels staan dan al voor je klaar.",
    "themeTitle": "Kies je licht",
    "themeSubtitle": "Thema's die passen bij de stemming van je schrijven.",
    "proTitle": "Begin met alles",
    "proSubtitle": "Begin met alles vanaf dag één. Probeer het gratis en houd het alleen als het zijn plek verdient.",
    "proTrust": "Geen advertenties. Geen trucjes. Altijd opzegbaar.",
    "tryProFree": "Probeer Pro gratis",
    "continueFree": "Doorgaan met het gratis abonnement",
    "allSetTitle": "Helemaal klaar",
    "allSetSubtitle": "Welkom bij Caliu. Maak het je eigen.",
    "startWriting": "Begin met schrijven",
    "firstNoteTitle": "Waar het begint",
    "firstNoteBody": "Dit is mijn eerste notitie. Ze leeft op dit apparaat, werkt offline en volgt me overal.",
    "firstNoteTask": "Eén gedachte opschrijven die het bewaren waard is",
    "next": "Volgende",
    "skip": "Overslaan",
    "back": "Terug",
    "intents": {
      "journal": "Dagboek",
      "ideas": "Ideeën",
      "work": "Werk",
      "study": "Studie",
      "reading": "Lezen",
      "plans": "Plannen"
    },
    "signInCta": "Inloggen of registreren",
    "continueWithoutAccount": "Doorgaan zonder account",
    "backupTitle": "Waar je notities staan",
    "backupSubtitle": "Ze beginnen op dit apparaat. Met een account synchroniseren ze, zodat een veilige kopie al je apparaten bereikt.",
    "syncOffTitle": "Synchronisatie staat uit",
    "syncOffBody": "Log in om je notities op al je apparaten te synchroniseren.",
    "backupSignedIn": "Je notities worden veilig gesynchroniseerd terwijl je schrijft.",
    "backupStageDevice": "Dit apparaat",
    "backupStageSafe": "Gesynchroniseerd",
    "backupStageEverywhere": "Al je apparaten",
    "freeNotes": "{{limit}} gratis notities, zonder account, voor altijd. Pro maakt ze onbeperkt."
  },
  "backup": {
    "evictionNotice": "Notities leven voorlopig alleen in deze browser. Browsers kunnen sitegegevens wissen als de opslag vol raakt.",
    "dismiss": "Sluiten",
    "signIn": "Inloggen"
  },
  "gate": {
    "share": "Log in om notities te delen.",
    "history": "Log in om versiegeschiedenis te bewaren.",
    "import": "Log in om notities te importeren."
  },
  "math": {
    "placeholder": "LaTeX",
    "sourceLabel": "LaTeX-bron"
  },
  "noteLimit": {
    "banner": "{{count}} van {{limit}} notities",
    "paywallTitle": "Je hebt de {{limit}} gratis notities bereikt",
    "paywallBody": "Bewerken, zoeken en synchroniseren blijven werken. Verplaats een notitie naar de prullenbak om een plek vrij te maken, of ga onbeperkt met Caliu Pro: maandelijks, jaarlijks of met een eenmalige lifetime-aankoop.",
    "importCapped": "Slechts {{count}} van {{total}} bestanden zijn geïmporteerd: het gratis plan staat {{limit}} notities toe."
  },
  "appUpdate": {
    "available": "Er is een nieuwe versie van Caliu beschikbaar."
  },
  "settings": {
    "title": "Instellingen",
    "account": "Account",
    "writing": "Schrijven",
    "keyboardShortcuts": "Toetscombinaties",
    "editor": "Editor",
    "yourNotes": "Je notities",
    "about": "Over",
    "noAccount": "Geen account",
    "sendFeedback": "Feedback versturen",
    "signInOrCreate": "Inloggen of registreren",
    "notesComeWithYou": "De notities op dit apparaat gaan met je mee.",
    "notSyncing": "Synchronisatie uit",
    "signInToSync": "Log in om je notities te synchroniseren.",
    "sync": "Synchronisatie",
    "security": "Beveiliging",
    "communications": "Communicatie",
    "newsletter": "Caliu-nieuwsbrief",
    "newsletterFooter": "Af en toe een korte e-mail over nieuwe versies en wat er aankomt in Caliu.",
    "newsletterError": "De nieuwsbrief kon niet worden bijgewerkt. Probeer het opnieuw.",
    "appearance": "Weergave",
    "themes": "Thema's",
    "sizing": "Grootte",
    "systemDefault": "Systeemstandaard",
    "separateThemes": "Aparte thema's voor licht en donker",
    "maxWidth": "Maximale breedte",
    "maxWidthHint": "Centreert tekst in een leesbare kolom op brede schermen",
    "markdownReturn": "Return in Markdown-stijl",
    "markdownReturnHint": "Return breekt de regel af. Druk twee keer op Return voor een nieuwe alinea",
    "newNoteStart": "Nieuwe notities beginnen met",
    "newNoteStartH1": "Kop 1",
    "newNoteStartH2": "Kop 2",
    "newNoteStartH3": "Kop 3",
    "newNoteStartH4": "Kop 4",
    "newNoteStartDate": "Datum",
    "newNoteStartDateIso": "Datum (ISO 8601)",
    "newNoteStartDateTime": "Datum en tijd",
    "newNoteStartDateTimeIso": "Datum en tijd (ISO 8601)",
    "newNoteStartEmpty": "Leeg",
    "newNoteStartHint": "Geldt voor notities die je in de app maakt.",
    "collapsibleSections": "Inklapbare secties",
    "collapsibleSectionsHint": "Hiermee kun je een kop en de inhoud ervan achter een pijl inklappen",
    "experimental": "Experimenteel",
    "general": "Algemeen"
  },
  "toolbar": {
    "toggleSidebar": "Toon/verberg navigatiekolom",
    "toggleInspector": "Inspecteur tonen/verbergen",
    "searchNotes": "Zoek notities",
    "newNote": "Nieuwe notitie",
    "findInNote": "Zoeken in notitie",
    "showToolbar": "Toon werkbalk",
    "hideToolbar": "Verberg werkbalk",
    "moreNoteActions": "Meer notitie-acties",
    "undo": "Ongedaan maken",
    "redo": "Opnieuw",
    "zenMode": "Zen-modus",
    "sourceMode": "Bronmodus",
    "richEditor": "Rich-text-editor",
    "sortBy": "Sorteer op",
    "bold": "Vet",
    "italic": "Cursief",
    "heading": "Kop",
    "list": "Lijst",
    "link": "Koppeling",
    "insert": "Voeg in",
    "more": "Meer",
    "strikethrough": "Doorgestreept",
    "table": "Tabel",
    "horizontalRule": "Horizontale lijn",
    "codeBlock": "Codeblok",
    "inlineCode": "Inline-code",
    "blockQuote": "Citaat",
    "math": "Formule",
    "highlight": "Markering",
    "bulletList": "Opsommingslijst",
    "orderedList": "Genummerde lijst",
    "photoLibrary": "Fotobibliotheek",
    "camera": "Camera",
    "files": "Bestanden",
    "yellow": "Geel",
    "green": "Groen",
    "blue": "Blauw",
    "pink": "Roze",
    "purple": "Paars",
    "heading1": "Kop 1",
    "heading2": "Kop 2",
    "heading3": "Kop 3",
    "heading4": "Kop 4",
    "heading5": "Kop 5",
    "heading6": "Kop 6",
    "removeHighlight": "Markering verwijderen"
  },
  "whatsNew": {
    "title": "Wat is er nieuw",
    "tagIconsTitle": "Pictogrammen getekend voor Caliu",
    "tagIconsBody": "Elk pictogram in de app is nieuw en speciaal voor Caliu gemaakt. Geef elk label een eigen pictogram en zoek ze in je eigen taal.",
    "newNoteStartTitle": "Begin notities op jouw manier",
    "newNoteStartBody": "Een nieuwe notitie kan openen met een kop, de datum van vandaag, datum en tijd, of een lege pagina. Kies het in Instellingen, onder Editor.",
    "typographyTitle": "Tekst, precies ingesteld",
    "typographyBody": "Kies de exacte tekstgrootte, regelhoogte en alinea-afstand van je notities, in Instellingen onder Typografie.",
    "typographySample": "Elke notitie volgt de grootte, regelhoogte en afstand die je instelt, tot op de punt.",
    "sampleMorningPages": "Ochtendpagina's",
    "newsletterTitle": "Nieuw: de Caliu-nieuwsbrief",
    "newsletterBody": "Vanaf nu vertelt een korte e-mail je wat er nieuw is in elke versie, in je eigen taal. Zet hem aan als je dat wilt. Je kunt dit altijd wijzigen in Instellingen."
  },
  "sharing": {
    "inviteByEmail": "Uitnodigen via e-mail",
    "invite": "Uitnodigen",
    "roleOwner": "Eigenaar",
    "roleEditor": "Kan bewerken",
    "roleViewer": "Kan bekijken",
    "generalAccess": "Algemene toegang",
    "shareWithLink": "Delen via een link",
    "accessRestricted": "Alleen uitgenodigde personen",
    "accessView": "Iedereen met de link kan bekijken",
    "accessEdit": "Iedereen met de link kan bewerken",
    "remove": "Verwijderen",
    "leave": "Verlaten",
    "leaveNote": "Notitie verlaten",
    "leaveConfirmTitle": "Deze notitie verlaten?",
    "leaveConfirmBody": "Ze verdwijnt op al je apparaten uit je lijsten. De eigenaar kan je opnieuw uitnodigen.",
    "leaveSelectedTitle": "Gedeelde notities verlaten?",
    "leaveSelectedBody_one": "Je verlaat {{count}} notitie die met jou gedeeld is. Je eigen notities gaan naar de prullenbak.",
    "leaveSelectedBody_other": "Je verlaat {{count}} notities die met jou gedeeld zijn. Je eigen notities gaan naar de prullenbak.",
    "sharedBy": "Gedeeld door {{name}}",
    "sharedList": "Gedeeld",
    "viewOnly": "Alleen bekijken",
    "accessNowEditor": "Je kunt deze notitie nu bewerken.",
    "accessNowViewer": "Je kunt deze notitie nu alleen nog bekijken.",
    "accessRemoved": "Je hebt geen toegang meer tot deze notitie.",
    "unsentSavedAsCopy": "Je niet verzonden wijzigingen zijn als kopie bewaard.",
    "privateNote": "Privénotitie",
    "memberLimit": "Een notitie kan met maximaal 50 personen worden gedeeld.",
    "rateLimit": "Te veel uitnodigingen. Probeer het later opnieuw.",
    "inviteFailed": "Kan de uitnodigingen niet versturen. Probeer het opnieuw.",
    "invalidEmail": "Voer een geldig e-mailadres in.",
    "onlineOnly": "Maak verbinding met internet om delen te beheren.",
    "you": "Jij",
    "ownerOnly": "Alleen de eigenaar kan wijzigen wie toegang heeft.",
    "unavailable": "Delen is nu niet beschikbaar. Probeer het later opnieuw.",
    "updateFailed": "Kan het delen niet bijwerken. Probeer het opnieuw.",
    "inviteInvalid": "Deze uitnodiging is niet meer geldig.",
    "copyLink": "Kopieer link",
    "invited": "Uitgenodigd",
    "copied": "Gekopieerd",
    "accessRestrictedHint": "Alleen mensen die je uitnodigt kunnen hem openen.",
    "onlyYouHint": "Alleen jij kunt hem openen.",
    "accessViewHint": "Iedereen met de link kan hem lezen, zonder account.",
    "accessEditHint": "Iedereen met de link kan hem bewerken.",
    "roleBelowLink": "Iedereen met de link kan bewerken, dus mensen die je uitnodigt kunnen ook bewerken.",
    "inviteAs": "Uitnodigen als",
    "revokeInvite": "Uitnodiging intrekken",
    "statusPeople_one": "{{count}} persoon",
    "statusPeople_other": "{{count}} personen",
    "publicLink": "Openbare link",
    "statusFrom": "Van {{name}}",
    "removeConfirmTitle": "{{name}} verwijderen?",
    "removeConfirmBody": "Deze persoon heeft dan geen toegang meer tot deze notitie.",
    "revokeConfirmTitle": "Uitnodiging voor {{name}} intrekken?",
    "revokeConfirmBody": "De uitnodigingslink werkt dan niet meer.",
    "peopleWithAccess": "Personen met toegang",
    "addPeoplePlaceholder": "Personen toevoegen via e-mail",
    "invitePro": "Personen uitnodigen hoort bij Caliu Pro.",
    "inviteKeepsAccess": "Uitgenodigde mensen houden toegang als je de link uitzet.",
    "youSuffix": "(jij)"
  },
  "noAccess": {
    "title": "Je hebt geen toegang tot deze notitie",
    "linkBody": "De eigenaar heeft hem niet met je gedeeld. Vraag of die je uitnodigt of de link aanzet.",
    "signedOutBody": "Log in met het account waarmee hij gedeeld is.",
    "inviteTitle": "Deze uitnodiging is niet meer geldig",
    "inviteBody": "Vraag de persoon die je uitnodigde om een nieuwe.",
    "removedTitle": "Je hebt geen toegang meer tot deze notitie",
    "removedBody": "De eigenaar heeft je verwijderd.",
    "removedCopyBody": "De eigenaar heeft je verwijderd. Je niet verzonden wijzigingen zijn als kopie in je notities bewaard.",
    "backToNotes": "Terug naar notities",
    "signIn": "Inloggen"
  }
}
